var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.components),function(value,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c(value,{tag:"component"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }